module.exports = require('./helpers/bundle-url').getBundleURL('hg7Qi') + "mydoge.f08fbaf5.png";